import React, {Component} from 'react'
import {Button, Drawer, Form} from 'antd';
import Swal from "sweetalert2";
import {withTourGuide} from "../guideComponent/withTourGuide";
import { HelpCircle } from "react-feather";

class EditSift extends Component {
    constructor() {
        super();
        this.triggerGuideOnce = this.triggerGuideOnce.bind(this);
        this.state = {
            showToleranceInfo: false,
        };
    }

    handleEdit = () => {
        let form = {
            id: this.props.data.sift_id,
            name: this.props.data.sift_name,
            tolerance: this.props.data.sift_late_tolerance,
        }
        this.props.request("shift/update", form, 'POST')
            .then(response => {
                if (response && response.success) {
                    const filter_data = JSON.parse(localStorage.getItem('Presensi-Company-Data'))
                    if (filter_data && filter_data._sift) {
                        const updateSift = filter_data._sift.map(sift =>
                            sift.sift_id === this.props.data.sift_id ? {
                                ...sift,
                                sift_name: this.props.data.sift_name,
                                sift_late_tolerance: this.props.data.sift_late_tolerance,
                            } : sift)
                        const updateFilter = {...filter_data, _sift: updateSift}
                        localStorage.setItem('Presensi-Company-Data', JSON.stringify(updateFilter))
                    }
                    this.setState({
                        sift_name : '',
                        sift_late_tolerance : '',
                    },() =>this.props.changeState({
                        visable: false,
                        sift_name : '',
                        sift_late_tolerance : '',
                        data: [],
                        isLoading: true,
                    },() => {
                        this.props.loadData()
                    }))
                    Swal.fire({
                        title: 'Berhasil!',
                        text: response.message,
                        icon: 'success'
                    })
                }
                if (response && response.failed) {
                    Swal.fire({
                        title: 'Gagal!',
                        text: response.message,
                        icon: 'warning',
                        confirmButtonText: 'OK'
                    })
                }
            });
    }

    triggerGuideOnce = (e, config) => {
        const { showGuide, isGuideActive, disabledKeys } = this.props;

        const target = e?.currentTarget ?? null;
        if (!target || !config?.key) return;
        if (disabledKeys?.includes(config.key)) return;
        if (isGuideActive) return;
        if (typeof showGuide !== 'function') return;
        showGuide(target, config);
    };

    render() {
        return (
            <Drawer
                title="Edit Sift"
                width={350}
                onClose={() => {
                    this.props.changeState({visable: false, sift_name:''});
                }}
                visible={this.props.data.visable}
                bodyStyle={{ paddingBottom: 80 }}
                footer={
                    <div
                        style={{
                            textAlign: 'right',
                        }}
                    >
                        <Button onChange={() => {
                            this.props.changeState({visable: false, sift_name:''});
                        }}
                                style={{ marginRight: 8 }}>
                            Batal
                        </Button>
                        <Button onClick={this.handleEdit} type="primary">
                            Simpan
                        </Button>
                    </div>
                }
            >
                <Form layout="vertical" hideRequiredMark>
                    <div className="form-group">
                        <label>Nama Shift</label>
                        <input name="sift_name" className="form-control col-xl-12 col-md-12" placeholder="Nama Shift..."
                               type="text" required="" value={this.props.data.sift_name}
                               onChange={(event) => {
                                   const target = event.target;
                                   const value  = target.value;
                                   const name   = target.name;
                                   this.props.changeState({
                                       [name]: value
                                   });
                               }}
                               onPointerEnter={(e) => {
                                   this.triggerGuideOnce(e, {
                                       key: "namaShiftEdit",
                                       title: "Nama Shift",
                                       content: "Isi nama shift pada kolom ini. Contoh: Shift Pagi, Shift Malam, atau Lintas Hari. Nama ini digunakan untuk identifikasi jadwal kerja."
                                   });
                               }}
                        />
                    </div>
                    <div className="form-group">
                        <label className="flex items-center gap-1.5">
                            Toleransi Terlambat (menit)
                            <HelpCircle className="ml-1" size={18}
                                style={{ cursor: 'pointer', color: '#1890ff' }}
                                onClick={() => this.setState(prev => ({ showToleranceInfo: !prev.showToleranceInfo }))}
                            />
                        </label>
                        {this.state.showToleranceInfo && (
                            <div style={{ position: 'relative', background: '#f0f8ff', border: '1px solid #91caff', borderRadius: 8, padding: '10px 12px', marginBottom: 8, fontSize: 13, color: '#333', lineHeight: 1.6 }}>
                                <button
                                    onClick={() => this.setState({ showToleranceInfo: false })}
                                    style={{ position: 'absolute', top: 6, right: 8, background: 'none', border: 'none', cursor: 'pointer', color: '#aaa', fontSize: 14, padding: 0 }}
                                    aria-label="Tutup"
                                >
                                    ✕
                                </button>
                                <div style={{ fontWeight: 600, marginBottom: 4 }}>
                                    Apa itu Toleransi Keterlambatan?
                                </div>
                                <div style={{ marginBottom: 4 }}>
                                    Toleransi keterlambatan adalah batas waktu tambahan yang diberikan kepada karyawan saat melakukan absensi masuk tanpa dianggap terlambat.
                                </div>
                                <div style={{ color: '#888', fontStyle: 'italic' }}>
                                    Pengaturan ini dapat diubah melalui <a href="/settings/presensi" style={{ color: '#1890ff', fontWeight: 600, fontStyle: 'normal' }}>Pengaturan Presensi</a>.
                                </div>
                            </div>
                        )}
                        <input name="sift_late_tolerance" className="form-control col-xl-12 col-md-12" placeholder="Nama Shift..."
                               type="number" required="" value={this.props.data.sift_late_tolerance}
                               onChange={(event) => {
                                   const target = event.target;
                                   const value  = target.value;
                                   const name   = target.name;
                                   this.props.changeState({
                                       [name]: value
                                   });
                               }}
                               onPointerEnter={(e) => {
                                   this.triggerGuideOnce(e, {
                                       key: "durasiTelatShiftEdit",
                                       title: "Durasi Keterlambatan",
                                       content: "Tentukan toleransi keterlambatan dalam menit. Jika karyawan absen melebihi durasi ini dari jam masuk shift, maka akan dihitung sebagai terlambat."
                                   });
                               }}
                        />
                    </div>
                </Form>
            </Drawer>

        )
    }
}

export default withTourGuide(EditSift)
